import * as t from "io-ts";
import nullable from "./nullable";
import { cargoTypeT } from "./types";
export const driverT = t.strict({
    driverId: t.string,
    orgId: t.string,
    organisationName: t.string,
    firstName: t.string,
    lastName: t.string,
    defaultTrailerId: nullable(t.string),
    defaultLanguage: t.string,
    driverLoginUrl: t.string,
    canAddRoutes: t.boolean,
    canAddInvoiceRef: t.boolean,
    sessionId: t.union([t.undefined, t.string]),
    defaultCargoType: nullable(cargoTypeT),
    arrivedDepartedButtonsDefaultEnabledForOrg: t.boolean,
    collectedDeliveredButtonsRemovedForOrg: t.boolean,
    cubicMetersButtonDefaultEnabledForOrg: t.boolean,
    clientRequiredOnCargos: t.boolean,
    canEditCargos: t.boolean,
    canAddInvoiceLines: t.boolean,
    canDeleteOwnCargoStops: t.boolean,
    canAddUndispatchedCargos: t.boolean,
    searchOriginLocation: nullable(t.strict({
        lat: t.number,
        lon: t.number,
    })),
});
//# sourceMappingURL=driver-me.js.map